import {
  FETCH_IMPACT_REDIRECT_FAILURE,
  FETCH_IMPACT_REDIRECT_LOADING,
  FETCH_IMPACT_REDIRECT_REQUEST,
  FETCH_IMPACT_REDIRECT_SUCCESS,
} from './actionTypes';

export const fetchImpactRedirectRequest = (payload: { genesisId?: string; tin?: string }) => ({
  type: FETCH_IMPACT_REDIRECT_REQUEST,
  payload,
});

export const fetchImpactRedirectSuccess = (url: string) => ({
  type: FETCH_IMPACT_REDIRECT_SUCCESS,
  payload: url,
});

export const fetchImpactRedirectFailure = (error: string) => ({
  type: FETCH_IMPACT_REDIRECT_FAILURE,
  payload: error,
});

export const fetchImpactRedirectLoading = (isLoading: boolean) => ({
  type: FETCH_IMPACT_REDIRECT_LOADING,
  payload: isLoading,
});
